// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ccdc788","455":"55d7bfe6","977":"a0dce45b"}[chunkId] + ".chunk.js";
};